import { render, staticRenderFns } from "./CasesCalendar.vue?vue&type=template&id=bd8dcf64"
import script from "./CasesCalendar.vue?vue&type=script&lang=js"
export * from "./CasesCalendar.vue?vue&type=script&lang=js"
import style0 from "./CasesCalendar.vue?vue&type=style&index=0&id=bd8dcf64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports